import { DocumentosPendientesPorFirmarDtoProps } from "./DTOs/DocumentosPendientesPorFirmarDto"

export const documentoComercialAdapter = (
  documento: DocumentosPendientesPorFirmarDtoProps
): DocumentosPendientesPorFirmarDtoProps => ({
  albaranes: documento?.albaranes,
  facturas: documento?.facturas,
  pedidos: documento?.pedidos,
  presupuestos: documento?.presupuestos,
  total: documento?.total,
})
